import { AllowedConditions } from './types';

export const getSubjectData = (conditions: Partial<AllowedConditions>) => conditions;
